import React, {ReactNode} from 'react';
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Switch,
} from "@mui/material";

type FormFieldSwitchProps = {
    label?: string;
    help?: string;
    checked?: boolean;
    onChange?: (value: boolean) => void;
};

const FormFieldSwitch: React.FC<FormFieldSwitchProps> = (props) => {
    return (
        <FormControl variant="standard" margin={'normal'}>
            <FormLabel>
                {props.label}
            </FormLabel>
            <FormControlLabel
                control={
                    <Switch checked={props.checked}
                            onChange={(e) => {
                                props.onChange && props.onChange(e.target.checked)
                            }}/>
                }
                label={props.help}/>
        </FormControl>
    );
};
export default FormFieldSwitch;